import { Col, Hidden, Row, ScreenClassRender, Visible, ScreenClassProvider } from 'react-grid-system';

import Container from './Container/Container';

const ReactGridComponents = {
  Col,
  Container,
  Hidden,
  Row,
  ScreenClassRender,
  Visible,
  ScreenClassProvider
};

export default ReactGridComponents;
